export class CuotaBancoDetalleDto {
    constructor(detalleData) {
        this.Cuotas = detalleData.Cuotas || 0;
        this.Monto = detalleData.Monto || '';
    }

    toJSON() {
        return JSON.parse(JSON.stringify({ ...this }))
    }
}